import {
  useEmailConfirmationMutation,
  useForgotPasswordMutation,
  useLoginMutation,
  useRegisterMutation,
  useResetPasswordMutation,
  UsersPermissionsLoginInput,
  UsersPermissionsRegisterInput,
} from "@/generated";

const useAuthUtils = () => {
  // Intentionally keep only auth mutations and their results here.

  const [
    loginMutation,
    { data: loginData, loading: loginLoading, error: loginError },
  ] = useLoginMutation();
  const [
    registerMutation,
    { data: registerData, loading: registerLoading, error: registerError },
  ] = useRegisterMutation();
  const [
    forgotPasswordMutation,
    {
      data: forgotPassData,
      loading: forgotPasswordLoading,
      error: forgotPasswordError,
    },
  ] = useForgotPasswordMutation();
  const [
    resetPasswordMutation,
    {
      data: resetPasswordData,
      loading: resetPasswordLoading,
      error: resetPasswordError,
    },
  ] = useResetPasswordMutation();
  const [
    emailConfirmationMutation,
    {
      data: emailConfirmationData,
      loading: emailConfirmationLoading,
      error: emailConfirmationError,
    },
  ] = useEmailConfirmationMutation();

  const signIn = (inputVariables: UsersPermissionsLoginInput) => {
    try {
      loginMutation({
        variables: { input: inputVariables },
      }).catch((e) => console.error(e));
    } catch (e) {
      console.error(e);
    }
  };

  const signUp = async (
    inputVariables: UsersPermissionsRegisterInput,
    token: string = ""
  ) => {
    try {
      await registerMutation({
        variables: { input: inputVariables },
        context: { headers: { "g-recaptcha-token": token } },
      });
    } catch (e) {
      console.error(e);
    }
  };

  const forgotPassword = (email: string) => {
    try {
      forgotPasswordMutation({
        variables: { email },
      });
    } catch (e) {
      console.error(e);
    }
  };

  const resetPassword = (
    password: string,
    passwordConfirmation: string,
    code: string
  ) => {
    try {
      resetPasswordMutation({
        variables: { password, passwordConfirmation, code },
      });
    } catch (e) {
      console.error(e);
    }
  };

  const confirmEmail = (confirmation: string) => {
    try {
      emailConfirmationMutation({
        variables: { confirmation },
      });
    } catch (e) {
      console.error(e);
    }
  };

  return {
    signIn,
    signUp,
    forgotPassword,
    resetPassword,
    confirmEmail,
    loginResponse: loginData,
    registerResponse: registerData,
    forgotPasswordResponse: forgotPassData,
    resetPasswordResponse: resetPasswordData,
    confirmEmailResponse: emailConfirmationData,
    loading:
      loginLoading ||
      registerLoading ||
      forgotPasswordLoading ||
      resetPasswordLoading ||
      emailConfirmationLoading,
    error:
      loginError ||
      registerError ||
      forgotPasswordError ||
      resetPasswordError ||
      emailConfirmationError,
  };
};

export default useAuthUtils;
